// @ts-strict-ignore
import React from 'react'
import { getValue } from '../../../utils/product-schema'

export const EligibilityAddon = ({ addon, data }) => {
  return (
    <div
      className='top-picks-card__details__addons top-picks-card__details__addonsHide'
      data-top-picks-addons
    >
      <div className='top-picks-card__details__addons__title'>{addon.title}</div>
      <div className='top-picks-card__details__addons__data'>
        {addon.criteria.map((c) => {
          return (
            getValue(c.value, data) !== undefined &&
            getValue(c.value, data) !== null && (
              <div className='top-picks-card__details__addons-rows'>
                <div className='top-picks-card__details__table-rows__name'>{c.label}</div>
                <div className='top-picks-card__details__table-rows__value'>
                  {getValue(c.value, data) === true
                    ? 'YES'
                    : getValue(c.value, data) === false
                    ? 'NO'
                    : getValue(c.value, data)}
                </div>
              </div>
            )
          )
        })}
      </div>
    </div>
  )
}

export const TableAddon = ({ rows }) => {
  return (
    <table className='TableAddon'>
      <tbody className='TableAddon__body'>
        {rows.map((row, i) => {
          return (
            <tr key={i}>
              {row.map((cell, j) => {
                return cell.type === 'th' ? (
                  <th
                    key={j}
                    colSpan={cell.colspan}
                    className={cell.value === '' ? 'TableAddon__body__header' : ''}
                  >
                    {cell.value}
                  </th>
                ) : (
                  <td colSpan={cell.colspan} key={j}>
                    {cell.value}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
